<template lang='pug'>
.store-switcher-v2
  button.a11y.site-selector.change-country(v-if="isNotEuRegion || isMounted")
    Icon(:name="country.icon")
    span.name {{country.name}}
    Icon.down(:name="showing ? 'arrow-down' : 'arrow-right'" fill='#666')
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { useUIStore } from '@/js/stores/uiStore'
import { useRogue } from '@/js/services/Rogue'
import { getDisplayCountry } from '@/js/helpers/countries'
import { getCookie } from '@/js/services/Utils'

const uiStore = useUIStore()
const rogue = useRogue()
const route = useRoute()

const isMounted = ref(false)
const preferredCountry = ref('')

onMounted(() => {
  if (['EUR', 'GBR'].includes(rogue.site.code)) {
    preferredCountry.value = getCookie('preferredCountry') || ''
  }
  isMounted.value = true
})

const isNotEuRegion = computed<boolean>(() => rogue.site.code !== 'EUR')
const showing = computed(() => uiStore.overlay === 'country-select-v2')
const sdst = computed(() => rogue.site.code === 'EUR' ? (route.query._sdst as string || '') : '')
const country = computed(() => getDisplayCountry(rogue, rogue.site.code === 'EUR' ? (sdst.value || preferredCountry.value) : ''))                                                    

</script>

<style lang='scss' scoped>
.store-switcher-v2 {
  display: flex;
  margin-left: $space-s;
  height: 100%;
}

.site-selector {
  display: flex;
  align-items: center;
  color: $color-gray-x-dark;
  padding: 0 $space-s;
  border-right: 1px solid $color-gray;
  text-decoration: none;

  >* {
    pointer-events: none;
  }

  &:hover {
    cursor: pointer;
    color: $color-black-light;
    text-decoration: underline;
  }

  &:first-child {
    border-left: 1px solid $color-gray;
  }
}

.name {
  padding: 0 $space-xxs;

  &:last-child {
    padding-right: 0;
  }
}

.down {
  height: 10px;
  width: 10px;
}
</style>
